import React, { useState, useEffect } from 'react';
import { Card, Table, Badge, Spinner, Nav } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { HOCPHANBOSUNG_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { trangThaiHocBoSungValue } from '../../../../utils/define';
import { Get } from '../../../../utils/httpProvider';
import moment from 'moment';

const HocPhanBoSung = ({ hoSoId, activeTab, setActiveTab }) => {
    const [selectedRow, setSelectedRow] = useState(null);
    
    const { isLoading, data: queryData } = useQuery(
        ['hocPhanBoSungData', hoSoId],
        () => Get(`${HOCPHANBOSUNG_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { 
            enabled: !!hoSoId,
            keepPreviousData: true
        }
    );

    // Xử lý data từ API
    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else {
            dataList = [queryData];
        }
    }

    useEffect(() => {
        if (dataList && dataList.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = dataList.find(item => item.id === prev.id);
                    return fresh || dataList[0];
                }
                return dataList[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [dataList]);

    const renderTrangThai = (val) => {
        switch (val) {
            case trangThaiHocBoSungValue.chuaHoc: return <Badge variant="warning">Chưa học</Badge>;
            case trangThaiHocBoSungValue.dangDiHoc: return <Badge variant="info">Đang đi học</Badge>;
            case trangThaiHocBoSungValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            default: return <Badge variant="secondary">Chưa xác định</Badge>;
        }
    };


    return (
        <>
        <Card className="h-100 card-sticky-layout">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <Nav variant="pills" activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="flex-row">
                        <Nav.Item>
                            <Nav.Link eventKey="hocPhanBoSung" className="font-weight-bold">Học phần bổ sung</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="hocPhanTienSi" className="font-weight-bold">Học phần chuyên sâu</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="chuyenDeTienSi" className="font-weight-bold">Chuyên đề tiến sĩ</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="tieuLuanTongQuan" className="font-weight-bold">Tiểu luận tổng quan</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </div>
            </Card.Header>
            <Card.Body className="d-flex flex-column">
                {isLoading ? (
                    <div className="text-center p-5 m-auto">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <div className="table-responsive flex-grow-1">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th className="text-center" width="50">STT</th>
                                        <th>Tên học phần</th>
                                        <th className="text-center">Ngày bắt đầu</th>
                                        <th className="text-center">Số tín chỉ</th>
                                        <th className="text-center">Điểm số</th>
                                        <th className="text-center">File công văn</th>
                                        <th className="text-center">Trạng thái</th>
                                        <th className="text-center">File kết quả</th>
                                    </tr>
                                </thead>
                            <tbody>
                                {dataList.length > 0 ? (
                                    dataList.map((item, index) => (
                                        <tr 
                                            key={item.id}
                                            onClick={() => setSelectedRow(item)}
                                            style={{ cursor: 'pointer' }}
                                            className={selectedRow?.id === item.id ? 'table-primary' : ''}
                                        >
                                            <td className="text-center">{index + 1}</td>
                                            <td>{item.tenHocPhan}</td>
                                            <td className="text-center">
                                                {item.ngayBatDau ? moment(item.ngayBatDau).format('DD/MM/YYYY') : ''}
                                            </td>
                                            <td className="text-center">{item.soHocPhan !== null && item.soHocPhan !== undefined ? item.soHocPhan : ''}</td>
                                            <td className="text-center">{item.diemSo !== null && item.diemSo !== undefined ? item.diemSo : ''}</td>
                                            <td className="text-center">
                                                {item.fileCongVan ? (
                                                    (() => {
                                                        const path = item.fileCongVan;
                                                        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
                                                        const safePath = path.startsWith('/') ? path : `/${path}`;
                                                        const fileUrl = path.startsWith('http') ? path : `${baseUrl}${safePath}`;
                                                        let name = path.split('/').pop() || 'File';
                                                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                                        return (
                                                            <a href={fileUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm text-left mb-1 mr-1" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                                                <i className="fas fa-paperclip mr-1"></i> {name}
                                                            </a>
                                                        );
                                                    })()
                                                ) : (
                                                    <span className="text-muted">Không có</span>
                                                )}
                                            </td>
                                            <td className="text-center">{renderTrangThai(item.trangThai)}</td>
                                            <td className="text-center">
                                                {item.fileKetQua ? (
                                                    (() => {
                                                        const path = item.fileKetQua;
                                                        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
                                                        const safePath = path.startsWith('/') ? path : `/${path}`;
                                                        const fileUrl = path.startsWith('http') ? path : `${baseUrl}${safePath}`;
                                                        let name = path.split('/').pop() || 'File';
                                                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                                        return (
                                                            <a href={fileUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm text-left mb-1 mr-1" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                                                <i className="fas fa-paperclip mr-1"></i> {name}
                                                            </a>
                                                        );
                                                    })()
                                                ) : (
                                                    <span className="text-muted">Không có</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center text-muted">
                                            Chưa có dữ liệu Học phần bổ sung (chỉ hiển thị khi Phòng HLĐT xác định và làm công văn cử đi học)
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        </div>
                    </>
                )}
            </Card.Body>
        </Card>
        </>
    );
};

export default HocPhanBoSung;
